/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBoxPlot = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v18h18v2H2V2zm7.999 0v2H10v2h3v8h-3v2h2v2H6v-2h2v-2H5V6h3V4H6V2zm9 0L21 4h-2v2h3v8h-3v2h2v2h-6v-2h2v-2h-3V6h3V4h-2V2zM11 11H7v1h4zm9 0h-4v1h4zm-9-3H7v1h4zm9 0h-4v1h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBoxPlot as ChartBoxPlot };
